
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";
import { useToast } from "@/components/ui/use-toast";
import { useTranslations } from "@/hooks/useTranslations";
import { useLanguage } from "@/components/LanguageContext";

interface ProfilePreviewButtonProps {
  publicUrl: string;
}

export const ProfilePreviewButton = ({ publicUrl }: ProfilePreviewButtonProps) => {
  const { toast } = useToast();
  const { t } = useTranslations("profile");
  const { language } = useLanguage();
  
  const handlePreview = () => {
    if (!publicUrl) {
      toast({
        title: t("previewError"),
        description: t("previewErrorDesc"),
        variant: "destructive",
      });
      return;
    }
    
    // Open preview in new tab with correct language path
    const basePath = language === 'pt' ? '/pt/pp/' : '/pp/';
    window.open(`${basePath}${publicUrl}`, '_blank');
  };
  
  return (
    <Button 
      onClick={handlePreview}
      variant="outline"
      className="gap-2 dark:text-white"
    >
      <ExternalLink className="h-4 w-4" />
      {t("preview")}
    </Button>
  );
};
